import React from 'react';
import { portal, Portal } from '../../../Configs/general';

import MyDebtsGDC from './MyDebts.GDC';

const MyDebts = props => {
  switch (portal) {
    case Portal.Gascaribe:
    case Portal.Efigas:
      return <MyDebtsGDC {...props} />;
    default:
      return <></>;
  }
};

export default MyDebts;
